import { SbbLoadingIndicatorCircle } from "@sbb-esta/lyne-react/loading-indicator-circle";
import { DisplayUser } from "components/DisplayFields/DisplayUser";
import { LyneButton } from "components/Lyne/LyneButton";
import { LynePeoplePicker } from "components/Lyne/LynePeoplePicker";
import { SlidingPanel } from "components/SlidingPanel/SlidingPanel";
import { ResourceKeys, useTranslations } from "providers";
import { useEditBoardGroupPanel } from "providers";
import React from "react";

export const EditBoardGroupPanel: React.FC = () => {
  const i18n = useTranslations();
  const {
    isOpen,
    isLoading,
    isAdding,
    deletingUserId,
    members,
    panelTitle,
    closePanel,
    handleAdd,
    setConfirmDeleteMember,
  } = useEditBoardGroupPanel();

  return (
    <SlidingPanel
      isOpen={isOpen}
      onCancel={closePanel}
      onClose={closePanel}
      header={<h1>{panelTitle}</h1>}
      footer={
        <LyneButton onClick={closePanel} kind="ghost">
          {i18n.Actions_Close}
        </LyneButton>
      }
    >
      {isLoading && <SbbLoadingIndicatorCircle />}
      {!isLoading && (
        <>
          <table className="table table-sm sbb-table-bs table-hover">
            <thead>
              <tr>
                <th>{i18n.User}</th>
                <th className="actions">{i18n.Actions}</th>
              </tr>
            </thead>
            <tbody>
              {members.map((m) => {
                const user = m.user;
                const userId = user?.id;
                return (
                  <tr key={m.id}>
                    <td>
                      <DisplayUser value={user} />
                    </td>
                    <td className="actions w-auto text-nowrap">
                      <button
                        type="button"
                        className="btn btn-link btn-sm text-danger"
                        disabled={deletingUserId === userId}
                        onClick={() => setConfirmDeleteMember({ id: userId, title: user?.displayName ?? user?.upn })}
                      >
                        {deletingUserId === userId ? (
                          <SbbLoadingIndicatorCircle />
                        ) : (
                          <i className="ms-Icon ms-Icon--Delete" />
                        )}{" "}
                        {i18n.Actions_Delete}
                      </button>
                    </td>
                  </tr>
                );
              })}
              {members.length === 0 && (
                <tr>
                  <td colSpan={2} className="text-muted">
                    {i18n.EmptyTable}
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <div className="mt-4">
            <LynePeoplePicker
              name="edit-board-group-member-picker"
              label={ResourceKeys.AddGroupMember}
              contextHelp={undefined}
              disabled={isAdding}
              autoFocus
              onChange={(user) => {
                if (user) handleAdd(user);
              }}
            />
          </div>
        </>
      )}
    </SlidingPanel>
  );
};
